import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';


const Index = (props) => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Scheme Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Scheme Validity Limit',
      attr: 'cust_scheme_validity_limit',
    },
    {
      ...defaultHeaderConfig,
      label: 'Description',
      attr: 'description',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_scheme.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]
  
  const onNewClick = () => {
    navigate('/schemes/new');
  }

  const onEditClick = (id) => {
    navigate(`/schemes/${id}/edit`)
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_scheme.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Scheme</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <ListingPageComponent
    key={PAGES.SchemesListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.SchemesListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Scheme List'}]}
    listingMutation={getApi('schemes')}
    className="scheme-listing-page"
    contentHeading="Scheme List - Results"
    headers={headers}
    recordsKey="schemes"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['ID', 'Name']}
  />

}

export default Index;
